import React,{useState ,useEffect}from "react";
import { TextField } from "@mui/material";
import { Label } from "@mui/icons-material";
import Tooltip from '@mui/material/Tooltip';
function InputLogin({ lable, lableIcon, type, name, value, onchange, classcustom, disabled, maskValue , tooltip }) {
  const [showPass, setShowPass] = useState(false);
  const [isMasked, setIsMasked] = useState(value === maskValue);

  useEffect(() => {
    setIsMasked(value === maskValue);
  }, [value, maskValue]);

  const showPassword = () => {
    if (!disabled) setShowPass((prev) => !prev);
  };

  const handleChange = (e) => {
    if (isMasked) {
      const typed = e.target.value.replace(maskValue, "").replace(maskValue?.slice(0, -1) ?? "", "");
      setIsMasked(false);
      onchange({ target: { value: typed, name } });
    } else {
      onchange(e);
    }
  };

  const inputEl = (
    <input
      className={`login-input ${classcustom}`}
      value={value}
      onChange={handleChange}
      type={type === 'password' && showPass ? 'text' : type}
      name={name}
      autoComplete="off"
      readOnly={disabled}
    />
  );

  return (
    <div className="input-field">
      <div className="input-label">
        {lableIcon}
        <span>{lable}</span>
      </div>

      {disabled && tooltip ? (   
        <Tooltip
          title={tooltip}
          placement="top"
          arrow
         componentsProps={{
  tooltip: {
    sx: {
      fontSize: '0.75rem',
      bgcolor: '#2d5490',
      color: '#e8eeff',
      border: '1px solid #4a7bc8',
      '& .MuiTooltip-arrow': { color: '#2d5490' },
    },
  },
}}
        >
          <span style={{ display: 'block', cursor: 'not-allowed' }}>
            {inputEl}
          </span>
        </Tooltip>
      ) : disabled ? (           
        <span style={{ display: 'block', cursor: 'not-allowed' }}>
          {inputEl}
        </span>
      ) : (
        inputEl
      )}

      {type === 'password' && (
        <svg
          className={`icon-eye${disabled ? ' icon-eye--disabled' : ''}`}
          onClick={showPassword}
          style={disabled ? { opacity: 0.3, cursor: 'not-allowed', pointerEvents: 'none' } : {}}
          width="25" height="24" viewBox="0 0 25 24" fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_4995_86315)">
            <circle cx="12.4996" cy="14.8136" r="3.81409" stroke="#424242" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3.49609 14.8138C3.49609 9.84117 7.52721 5.81006 12.4998 5.81006C17.4725 5.81006 21.5036 9.84117 21.5036 14.8138" stroke="#424242" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_4995_86315">
              <rect width="24" height="24" fill="white" transform="translate(0.5)" />
            </clipPath>
          </defs>
        </svg>
      )}
    </div>
  );
}


export default InputLogin;
